import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import OnboardingStepper from "components/Account/Onboarding/OnboardingStepper";
import TextArea from "components/General/Form/TextArea";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import ProfileCategoryGrid from "components/Account/Profile/ProjectCategoryGrid";
import { connect } from "react-redux";

class Cause extends React.Component {
  state = {
    cause: "",
    projectCat: [],
    projectInterest: [],
    above18: false,
  };

  componentDidMount() {
    ProfileHelper.getCategory(this);
    AxiosConfig.get("profile/details/").then((res) => {
      this.setState({
        projectInterest: res.data.project_interest,
        cause: res.data.cause,
      });
    });
  }

  onDataChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  redirectUser() {
    let userList = JSON.parse(sessionStorage.getItem("userList"));
    let userEmail = sessionStorage.getItem("userEmail");
    let isAdult = false;
    for (let i in userList) {
      if (userList[i].email === userEmail) {
        isAdult = userList[i].is_above_eighteen;
      }
    }
    if (isAdult === true) {
      this.props.history.push(`/onboarding-family-account`);
    } else {
      this.props.dispatch({ type: "LOGIN_SUCCESS" });
      this.props.history.push(`/projects`);
    }
  }
  onNextClicked(event) {
    event.preventDefault();
    let form_data = new FormData();
    this.state.projectInterest.forEach((item) => {
      form_data.append("project_interest", item);
    });
    form_data.append("cause", this.state.cause);

    return AxiosConfig.put("profile/details/", form_data, {
      headers: { "content-type": "multipart/form-data" },
    })
      .then(this.onboardingComplete(), this.redirectUser())
      .catch();
  }

  onSkipClicked(event) {
    this.onboardingComplete();
    this.redirectUser();
  }

  onboardingComplete() {
    AxiosConfig.post("account/onboarding_complete/");
  }

  render() {
    return (
      <div>
        <div className="onboarding_header">
          <div className="onboarding_header_text">
            <TextTheme
              message="Before we start, let's build your"
              className="text_xm text_white text_bold"
            />
            <TextTheme
              message="Personalized Social Impact Profile!"
              className="text_xm text_white text_bold"
            />
          </div>
          <div className="onboarding_header_stepper">
            <OnboardingStepper currentOnboardingStep="3" />
          </div>
        </div>
        <div className="onboarding_content">
          <form>
            <div
              style={{ width: "fit-content", align: "center", margin: "auto" }}
            ></div>
            <div style={{ marginTop: "20px" }}>
              <ProfileCategoryGrid
                projectCat={this.state.projectCat}
                handleChange={ProfileHelper.onProjectInterestDataChange.bind(
                  this
                )}
                selectedOptions={this.state.projectInterest}
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              <TextArea
                title="My favorite causes include:"
                rows="6"
                placeholder="Name some specific causes you would like to help out (e.g. sea turtle resuce, rainforests, and air polution)."
                name="cause"
                value={this.state.cause}
                handleChange={this.onDataChange.bind(this)}
              />
            </div>
            <div className="onboarding_button_options">
              <RoundedButton
                title="Skip for now, maybe later."
                buttonClassName="background_white"
                textThemeClassName="text_medium text_dark_orange"
                handleOnClick={this.onSkipClicked.bind(this)}
              />
              <RoundedButton
                title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
                buttonClassName="background_dark_orange"
                textThemeClassName="text_medium text_white"
                handleOnClick={this.onNextClicked.bind(this)}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect()(Cause);
